<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in routeList" :key="index" :to="{
          name: item.name,
          query: {
            id: item.query.id,
            flag: item.query.flag,
            name: item.query.name
          }
        }">
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ name }}</h1>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;">
          <el-tab-pane label="采集点数据">
            <device-data-show :deviceId="ids"></device-data-show>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>
<script>
  import deviceDataShow from '@/components/device/deviceDataShow.vue' //引入数据展示子组件

  export default {
    components: {
      deviceDataShow
    },
    data() {
      return {
        routeList: this.$route.meta.routeList,
        ids: this.$route.query.id,
        name: this.$route.query.name,
      };
    },
    created() {},
    methods: {},
    mounted() {}
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/equipmentViewData.vue